import { Component } from '@angular/core';

@Component({
  selector: 'CPF-find-contract-page',
  templateUrl: './find-contract-page.component.html',
  styleUrls: ['./find-contract-page.component.scss']
})
export class FindContractPageComponent {

}
